/* DOMOTEC B2B ORDERING — piece quantities with carton intelligence */
(function () {
  'use strict';

  var cfg = window.DomotecMOQConfig || {};
  if (!cfg.enabled) return;

  var EUR_MIN_CENTS = Number(cfg.minimumOrderEurCents || 25000);
  var PLN_MIN_CENTS = 100000;
  var SKU_MIN_QTY = 5;
  var FALLBACK_PLN_PER_EUR = 4.40;
  var locked = cfg.orderingLocked !== false;
  var currentEurRate = null;

  function money(cents, currency) {
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: currency || cfg.currency || 'PLN',
      minimumFractionDigits: 2
    }).format(Number(cents || 0) / 100);
  }

  function formatNumber(value) {
    return Number(value || 0).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function parsePln(text) {
    var cleaned = String(text || '').replace(/[^0-9,.-]/g, '').replace(/\s/g, '');
    if (cleaned.indexOf(',') > -1) cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    return Number(cleaned);
  }

  function customerCanSeePrices() {
    if (cfg.customerLoggedIn === true && cfg.customerVerified === true) return true;
    return Array.prototype.some.call(document.querySelectorAll('.price-item, .cart-item__price-wrapper, .cart-item__totals, .totals__total-value, .cart__footer'), function (el) {
      return /(?:PLN|zł|€)\s*\d|\d[\d\s.,]*\s*(?:PLN|zł|€)/i.test(el.textContent || '');
    });
  }

  function unitPriceCents(carton) {
    var listed = Number(cfg.productPriceCents || 0);
    if (!listed) return 0;
    return cfg.priceMode === 'piece' ? listed : Math.round(listed / Math.max(1, carton));
  }

  function getEurRate() {
    return fetch('https://api.nbp.pl/api/exchangerates/rates/a/eur/?format=json', { cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('NBP rate unavailable');
        return response.json();
      })
      .then(function (data) {
        return Number(data && data.rates && data.rates[0] && data.rates[0].mid) || FALLBACK_PLN_PER_EUR;
      })
      .catch(function () { return FALLBACK_PLN_PER_EUR; });
  }

  function addEurPrices(rate) {
    if (!rate || rate <= 0 || !customerCanSeePrices()) return;
    document.querySelectorAll('.price-item--regular, .price-item--sale, .price__regular .price-item, .card-information .price, .card__information .price').forEach(function (price) {
      if (price.querySelector('.domotec-eur-price')) return;
      var pln = parsePln(price.childNodes[0] && price.childNodes[0].textContent || price.textContent);
      if (!pln || pln <= 0) return;
      var secondary = document.createElement('small');
      secondary.className = 'domotec-eur-price';
      secondary.textContent = '≈ €' + formatNumber(pln / rate) + ' · kurs NBP';
      price.appendChild(secondary);
    });
  }

  function quantityInputs(scope) {
    var inputs = Array.prototype.slice.call((scope || document).querySelectorAll('input[name="quantity"]'));
    if (!inputs.length) inputs = Array.prototype.slice.call(document.querySelectorAll('input[name="quantity"]'));
    return inputs;
  }

  function addHiddenProperty(form, name, value) {
    var selector = 'input[name="properties[' + name + ']"]';
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      form.appendChild(input);
    }
    input.value = value;
  }

  function setupProductChooser() {
    var carton = Math.floor(Number(cfg.cartonSize || 0));
    if (!carton) return;
    var moq = Math.min(SKU_MIN_QTY, carton);
    var cartonQty = carton;
    var anchorForm = document.querySelector('form[action*="/cart/add"]');
    if (!anchorForm || document.querySelector('.domotec-pack-chooser')) return;

    var section = anchorForm.closest('.product, .product__info-container, section') || anchorForm.parentNode;
    var each = unitPriceCents(carton);
    var chooser = document.createElement('section');
    chooser.className = 'domotec-pack-chooser';
    chooser.setAttribute('aria-label', 'Wybierz sposób zamówienia');
    chooser.innerHTML =
      '<div class="domotec-pack-heading"><span class="domotec-step">1</span><div><strong>Wybierz ilość</strong><small>Cena jest liczona za sztukę. Magazyn przygotuje zamówienie w bezpiecznych pakietach.</small></div></div>' +
      '<div class="domotec-pack-options" role="group" aria-label="Sposób zamówienia">' +
        '<button type="button" class="domotec-pack-option is-selected tone-starter" data-kind="starter" data-qty="' + moq + '"><span>Minimum produktu</span><b>' + moq + ' szt.</b><small>' + (carton < SKU_MIN_QTY ? '1 pełny karton — wyjątek dla małego opakowania' : 'dowolny produkt od 5 sztuk') + '</small></button>' +
        '<button type="button" class="domotec-pack-option tone-carton" data-kind="carton" data-qty="' + cartonQty + '"><span>Kup kartony</span><b>od 1 kartonu</b><small>' + carton + ' szt. w kartonie</small></button>' +
      '</div>' +
      '<div class="domotec-bulk-control" hidden><label for="DomotecBulkCartons">Liczba pełnych kartonów</label><div><button type="button" data-bulk-minus aria-label="Mniej kartonów">−</button><input id="DomotecBulkCartons" type="number" min="1" step="1" value="1" inputmode="numeric"><button type="button" data-bulk-plus aria-label="Więcej kartonów">+</button></div></div>' +
      '<div class="domotec-selection-summary" aria-live="polite"></div>' +
      '<p class="domotec-order-minimum">Minimum całego koszyka: <strong>1 000 PLN lub €250</strong>. Ceny EUR są przeliczane według dziennego kursu NBP.</p>' +
      '<form class="domotec-direct-add" method="post" action="' + ((window.routes && window.routes.cart_add_url) || '/cart/add') + '">' +
        '<input type="hidden" name="id" value="' + String(cfg.productVariantId || '') + '">' +
        '<input type="hidden" name="quantity" value="' + moq + '">' +
        '<button type="submit" name="add" class="button button--full-width button--primary">Dodaj wybraną ilość do koszyka</button>' +
      '</form>';

    anchorForm.parentNode.insertBefore(chooser, anchorForm);
    var form = chooser.querySelector('.domotec-direct-add');
    var inputs = [form.querySelector('input[name="quantity"]')];
    addHiddenProperty(form, 'Jednostka zamówienia', 'sztuka');
    addHiddenProperty(form, 'Pełny karton', carton + ' szt.');
    addHiddenProperty(form, 'Minimalny pakiet', moq + ' szt.');

    function setQuantity(qty, kind) {
      qty = Math.max(moq, Math.floor(Number(qty || moq)));
      inputs.forEach(function (input) {
        input.min = String(moq);
        input.step = '1';
        input.value = String(qty);
        input.dataset.domotecMoq = String(moq);
      });
      chooser.querySelectorAll('.domotec-pack-option').forEach(function (button) {
        var selected = button.dataset.kind === kind;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      var cartons = Math.floor(qty / carton);
      var loose = qty % carton;
      var description = cartons ? cartons + (cartons === 1 ? ' pełny karton' : ' pełne kartony') : 'minimum produktu';
      if (cartons && loose) description += ' + ' + loose + ' szt.';
      var total = each * qty;
      var eurTotal = currentEurRate ? ' · ≈ €' + formatNumber(total / 100 / currentEurRate) : '';
      var eurEach = currentEurRate ? ' · ≈ €' + formatNumber(each / 100 / currentEurRate) + ' / szt.' : '';
      chooser.querySelector('.domotec-selection-summary').innerHTML =
        '<span><strong>' + qty + ' szt.</strong><small>' + description + '</small></span>' +
        (customerCanSeePrices()
          ? '<span><strong>' + money(total, 'PLN') + eurTotal + '</strong><small>' + money(each, 'PLN') + ' / szt.' + eurEach + '</small></span>'
          : '<span><strong>Zaloguj się, aby zobaczyć ceny</strong><small>Ceny są dostępne po weryfikacji konta.</small></span>');
      var addButton = chooser.querySelector('.domotec-direct-add [name="add"]');
      if (addButton) addButton.textContent = 'Dodaj ' + qty + ' szt. do koszyka';
    }

    chooser.addEventListener('click', function (event) {
      var option = event.target.closest('.domotec-pack-option');
      if (option) {
        var kind = option.dataset.kind;
        chooser.querySelector('.domotec-bulk-control').hidden = kind !== 'carton';
        setQuantity(Number(option.dataset.qty), kind);
        return;
      }
      var bulkInput = chooser.querySelector('#DomotecBulkCartons');
      if (event.target.closest('[data-bulk-minus]')) bulkInput.value = Math.max(1, Number(bulkInput.value || 1) - 1);
      if (event.target.closest('[data-bulk-plus]')) bulkInput.value = Number(bulkInput.value || 1) + 1;
      if (event.target.closest('[data-bulk-minus], [data-bulk-plus]')) setQuantity(Number(bulkInput.value) * carton, 'carton');
    });
    chooser.querySelector('#DomotecBulkCartons').addEventListener('change', function (event) {
      event.target.value = Math.max(1, Math.floor(Number(event.target.value || 1)));
      setQuantity(Number(event.target.value) * carton, 'carton');
    });
    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var qty = Math.max(moq, Math.floor(Number(input.value || moq)));
        var kind = qty % carton === 0 ? 'carton' : 'starter';
        setQuantity(qty, kind);
      });
    });
    form.addEventListener('submit', function (event) {
      var qty = Number((inputs[0] && inputs[0].value) || 0);
      if (qty < moq) {
        event.preventDefault();
        setQuantity(qty, 'starter');
        chooser.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    chooser.domotecRefreshPrice = function () {
      setQuantity(Number(inputs[0].value || moq), chooser.querySelector('.domotec-pack-option.is-selected')?.dataset.kind || 'starter');
    };
    setQuantity(moq, 'starter');
  }

  function classify(qty, carton, moq) {
    if (qty < moq) return { tone: 'invalid', label: 'Minimum ' + moq + ' szt.' };
    if (qty % carton === 0) return { tone: 'carton', label: (qty / carton) + (qty === carton ? ' pełny karton' : ' pełne kartony') };
    return { tone: 'starter', label: 'Sztuki / opakowanie mieszane' };
  }

  function organizeCartRows() {
    var rows = Array.prototype.slice.call(document.querySelectorAll('.cart-item[data-domotec-carton]'));
    if (!rows.length || !rows[0].parentNode) return;
    function rank(row) {
      if (row.classList.contains('tone-carton')) return 0;
      if (row.classList.contains('tone-starter')) return 1;
      return 2;
    }
    var sorted = rows.slice().sort(function (a, b) { return rank(a) - rank(b); });
    var signature = sorted.map(function (row) {
      return (row.dataset.key || row.id || row.querySelector('a')?.getAttribute('href') || '') + ':' + rank(row);
    }).join('|');
    var parent = rows[0].parentNode;
    if (parent.dataset.domotecOrderSignature === signature) return;
    parent.dataset.domotecOrderSignature = signature;
    sorted.forEach(function (row) { parent.appendChild(row); });
    parent.querySelectorAll('.domotec-cart-group-title').forEach(function (title) { title.remove(); });
    [
      { tone: 'tone-carton', text: 'PEŁNE KARTONY', detail: 'Zamknięte kartony — przygotowywane jako pierwsze' },
      { tone: 'tone-starter', text: 'SZTUKI / OPAKOWANIA MIESZANE', detail: 'Zakupione sztuki poza pełnymi kartonami' },
      { tone: 'tone-invalid', text: 'WYMAGA POPRAWY', detail: 'Ilość poniżej minimum produktu' }
    ].forEach(function (group) {
      var first = sorted.find(function (row) { return row.classList.contains(group.tone); });
      var details = first && first.querySelector('.cart-item__details');
      if (!details) return;
      var title = document.createElement('div');
      title.className = 'domotec-cart-group-title ' + group.tone;
      title.innerHTML = '<b>' + group.text + '</b><small>' + group.detail + '</small>';
      details.insertBefore(title, details.firstChild);
    });
  }

  function enhanceCartRows() {
    var rows = document.querySelectorAll('.cart-item[data-domotec-carton]');
    if (!rows.length) return;
    if (!document.querySelector('.domotec-cart-legend')) {
      var legend = document.createElement('div');
      legend.className = 'domotec-cart-legend';
      legend.innerHTML = '<strong>Jak czytać koszyk</strong><span class="tone-starter">Minimum 5 szt.</span><span class="tone-carton">Pełny karton</span><span class="tone-bulk">Hurt / wiele kartonów</span>';
      var cartItems = document.querySelector('cart-items .page-width, .cart-items');
      if (cartItems) cartItems.insertBefore(legend, cartItems.firstChild);
    }
    rows.forEach(function (row) {
      var carton = Math.floor(Number(row.dataset.domotecCarton || 0));
      if (!carton) return;
      var moq = Math.min(SKU_MIN_QTY, carton);
      var fullCartonQty = carton;
      var input = row.querySelector('input[name="updates[]"], .quantity__input');
      var qty = Math.floor(Number(input && input.value || row.dataset.domotecQuantity || 0));
      var state = classify(qty, carton, moq);
      if (input) {
        input.min = String(moq);
        input.step = '1';
        input.dataset.domotecMoq = String(moq);
        input.dataset.domotecCarton = String(carton);
      }
      var full = Math.floor(qty / carton);
      var loose = qty % carton;
      var breakdown = full ? full + (full === 1 ? ' karton' : ' kartony') : qty + ' szt. w pakiecie częściowym';
      if (full && loose) breakdown += ' + ' + loose + ' szt.';
      var listedPrice = Number(row.dataset.domotecCurrentUnitPrice || 0);
      var piecePrice = cfg.priceMode === 'piece' ? listedPrice : Math.round(listedPrice / Math.max(1, carton));
      var priceLine = '';
      if (customerCanSeePrices()) {
        priceLine = money(piecePrice, 'PLN') + ' / szt. · wartość ' + money(piecePrice * qty, 'PLN');
        if (currentEurRate) priceLine += ' · ≈ ' + money(Math.round(piecePrice * qty / currentEurRate), 'EUR');
      }
      var target = row.querySelector('[data-domotec-line-summary]');
      if (!target) {
        target = document.createElement('div');
        target.setAttribute('data-domotec-line-summary', '');
        var details = row.querySelector('.cart-item__details');
        if (details) details.appendChild(target);
      }
      var signature = [qty, carton, moq, state.tone].join(':');
      if (target.dataset.domotecSignature === signature) return;
      target.dataset.domotecSignature = signature;
      target.className = 'domotec-cart-line-summary tone-' + state.tone;
      row.classList.remove('tone-carton', 'tone-starter', 'tone-invalid');
      row.classList.add('tone-' + state.tone);
      target.innerHTML =
        '<span class="domotec-line-badge">' + state.label + '</span>' +
        '<div><b>' + qty + ' szt. w koszyku</b><small>' + breakdown + ' · karton: ' + carton + ' szt. · minimum: ' + moq + ' szt.</small>' + (priceLine ? '<small>' + priceLine + '</small>' : '<small><a href="/account/login">Zaloguj się do konta klienta, aby zobaczyć ceny</a></small>') + '</div>' +
        (state.tone === 'invalid' ? '<div class="domotec-fix-actions"><button type="button" data-domotec-fix-qty="' + moq + '">Ustaw minimum: ' + moq + ' szt.</button><button type="button" data-domotec-fix-qty="' + fullCartonQty + '">Pełny karton: ' + fullCartonQty + ' szt.</button></div>' : '');
    });
    organizeCartRows();
  }

  function cartHasInvalidQuantities() {
    return Array.prototype.some.call(document.querySelectorAll('.cart-item[data-domotec-carton]'), function (row) {
      var carton = Math.max(1, Number(row.dataset.domotecCarton || 1));
      var moq = Math.min(SKU_MIN_QTY, carton);
      var input = row.querySelector('input[name="updates[]"], .quantity__input');
      var qty = Number(input && input.value || row.dataset.domotecQuantity || 0);
      return qty > 0 && qty < moq;
    });
  }

  function normalizeCartQuantity(input) {
    var moq = Number(input.dataset.domotecMoq || 1);
    var qty = Number(input.value || 0);
    if (qty === 0) return;
    var normalized = Math.max(moq, Math.floor(qty));
    if (normalized !== qty) {
      input.value = String(normalized);
      input.setCustomValidity('Minimalna ilość dla produktu to 5 sztuk.');
      input.reportValidity();
      setTimeout(function () { input.setCustomValidity(''); }, 1800);
    }
  }

  function simulatedCartTotal() {
    var sum = 0;
    document.querySelectorAll('.cart-item[data-domotec-carton]').forEach(function (row) {
      var carton = Number(row.dataset.domotecCarton || 1);
      var currentPrice = Number(row.dataset.domotecCurrentUnitPrice || 0);
      var qtyInput = row.querySelector('input[name="updates[]"], .quantity__input');
      var qty = Number(qtyInput && qtyInput.value || row.dataset.domotecQuantity || 0);
      var piecePrice = cfg.priceMode === 'piece' ? currentPrice : Math.round(currentPrice / Math.max(1, carton));
      sum += piecePrice * qty;
    });
    return sum || Number(cfg.cartTotalCents || 0);
  }

  function enforceCartMinimum(rate) {
    var cart = document.querySelector('form[action*="/cart"], cart-items');
    if (!cart) return;
    var currency = String(cfg.currency || 'PLN').toUpperCase();
    var total = simulatedCartTotal();
    var minimum = currency === 'EUR' ? EUR_MIN_CENTS : PLN_MIN_CENTS;
    var shortfall = Math.max(0, minimum - total);
    var invalidQuantities = cartHasInvalidQuantities();
    var banner = document.querySelector('.domotec-minimum-banner');
    if (!banner) {
      banner = document.createElement('section');
      banner.className = 'domotec-minimum-banner';
      var footer = document.querySelector('.cart__footer, #main-cart-footer, .drawer__footer');
      if (footer) footer.parentNode.insertBefore(banner, footer);
    }
    if (!banner) return;
    if (!customerCanSeePrices()) {
      banner.classList.remove('is-ready');
      if (banner.dataset.domotecSignature !== 'price-locked') {
        banner.dataset.domotecSignature = 'price-locked';
        banner.innerHTML =
          '<div class="domotec-minimum-head"><span class="domotec-step">2</span><div><strong>Nie jesteś zalogowany w sklepie</strong><small>Adres e-mail zapamiętany w kasie lub Shop Pay nie oznacza zalogowania do konta klienta. Zaloguj się, aby zobaczyć ceny, pasek minimum i aktywować zakup.</small></div></div>' +
          '<div class="domotec-checkout-note"><a class="button button--primary" href="/account/login"><b>Zaloguj się do konta klienta</b></a></div>';
      }
      document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]').forEach(function (button) {
        if ('disabled' in button) button.disabled = true;
        button.classList.add('domotec-checkout-disabled');
        button.setAttribute('aria-disabled', 'true');
        button.dataset.domotecBlocked = 'true';
      });
      return;
    }
    var percent = Math.min(100, Math.round(total / minimum * 100));
    var minimumText = currency === 'EUR' ? '€250' : '1 000 PLN';
    var shortfallText = currency === 'EUR' ? money(shortfall, 'EUR') : money(shortfall, 'PLN');
    var signature = [total, minimum, shortfall, locked, invalidQuantities].join(':');
    banner.classList.toggle('is-ready', shortfall === 0 && !invalidQuantities);
    if (banner.dataset.domotecSignature !== signature) banner.innerHTML =
      '<div class="domotec-minimum-head"><span class="domotec-step">2</span><div><strong>' + (invalidQuantities ? 'Popraw ilości oznaczone na czerwono' : shortfall ? 'Minimum zamówienia: ' + minimumText : 'Minimum zamówienia osiągnięte') + '</strong><small>' + (invalidQuantities ? 'Każdy produkt musi spełniać swoje minimum przed przejściem do kasy.' : shortfall ? 'Dodaj jeszcze ' + shortfallText + ', aby przejść do kasy.' : 'Koszyk jest gotowy do zamówienia.') + '</small></div></div>' +
      '<div class="domotec-progress"><i style="width:' + percent + '%"></i></div>' +
      '<div class="domotec-checkout-note"><b>W kasie zobaczysz:</b> liczbę sztuk, pakowanie kartonowe, minimum pakietu, dane dostawy i płatności.</div>';
    banner.dataset.domotecSignature = signature;

    document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]').forEach(function (button) {
      var blocked = locked || shortfall > 0 || invalidQuantities;
      if ('disabled' in button) button.disabled = blocked;
      button.classList.toggle('domotec-checkout-disabled', blocked);
      button.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      button.dataset.domotecBlocked = blocked ? 'true' : 'false';
      if (!button.dataset.domotecGuard) {
        button.dataset.domotecGuard = 'true';
        button.addEventListener('click', function (event) {
          if (button.dataset.domotecBlocked === 'true') {
            event.preventDefault();
            banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    });
  }

  function correctSoldOutLabels() {
    document.querySelectorAll('.badge, .card__badge span, [class*="sold"]').forEach(function (el) {
      var text = (el.textContent || '').trim().toLowerCase();
      if (text === 'wyprzedane' || text === 'sold out' || text === 'out of stock') {
        el.textContent = 'Dostępny na zamówienie';
        el.classList.add('domotec-available-badge');
      }
    });
  }

  function collectionQuantityInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('.card-wrapper .quantity__input, .product-card-wrapper .quantity__input, .grid__item .quantity__input')).filter(function (input) {
      return !input.closest('.cart-item, .product__info-container, .domotec-pack-chooser');
    });
  }

  function enforceCollectionMinimums() {
    collectionQuantityInputs().forEach(function (input) {
      var card = input.closest('.card-wrapper, .product-card-wrapper, .grid__item');
      var cartonMatch = card && (card.textContent || '').match(/Sztuk\s*\/\s*karton\s*(\d+)/i);
      var cardCarton = cartonMatch ? Number(cartonMatch[1]) : 0;
      var cardMoq = cardCarton > 0 ? Math.min(SKU_MIN_QTY, cardCarton) : SKU_MIN_QTY;
      input.min = '0';
      input.step = '1';
      input.dataset.domotecCollectionMoq = String(cardMoq);
      var qty = Number(input.value || 0);
      if (qty > 0 && qty < cardMoq) input.value = String(cardMoq);
      var wrapper = input.closest('.quantity, quantity-input') || input.parentNode;
      if (wrapper && !wrapper.dataset.domotecMinimumNote) {
        var note = document.createElement('small');
        note.className = 'domotec-card-minimum';
        note.textContent = 'Minimum: ' + cardMoq + ' szt.';
        wrapper.parentNode.insertBefore(note, wrapper);
        wrapper.dataset.domotecMinimumNote = 'true';
      }
    });
  }

  function lockPreviewOrdering() {
    if (!locked) return;
    if (!document.querySelector('.domotec-test-banner')) {
      var banner = document.createElement('div');
      banner.className = 'domotec-test-banner';
      banner.innerHTML = '<b>TRYB TESTOWY</b><span>Sprawdź wybór pakietów i koszyk. Zamówienia są wyłączone do czasu bezpiecznej zmiany cen na ceny za sztukę.</span>';
      document.body.insertBefore(banner, document.body.firstChild);
    }
    document.querySelectorAll('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"]').forEach(function (button) {
      button.disabled = true;
      button.title = 'Tryb testowy — zamówienia są jeszcze wyłączone';
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('.cart-item input[name="updates[]"], .cart-item .quantity__input')) {
      normalizeCartQuantity(event.target);
      setTimeout(enhanceCartRows, 0);
    }
  });

  document.addEventListener('click', function (event) {
    var quantityButton = event.target.closest('.quantity__button');
    if (quantityButton) {
      var quantityWrapper = quantityButton.closest('.quantity, quantity-input') || quantityButton.parentNode;
      var collectionInput = quantityWrapper && quantityWrapper.querySelector('.quantity__input');
      if (collectionInput && collectionInput.dataset.domotecCollectionMoq) {
        var collectionMoq = Number(collectionInput.dataset.domotecCollectionMoq || SKU_MIN_QTY);
        var current = Number(collectionInput.value || 0);
        var ariaLabel = (quantityButton.getAttribute('aria-label') || '').toLowerCase();
        var isMinus = quantityButton.name === 'minus' || quantityButton.classList.contains('quantity__button--minus') || ariaLabel.indexOf('zmniejsz') > -1;
        if (!isMinus && current < collectionMoq) {
          event.preventDefault();
          event.stopImmediatePropagation();
          collectionInput.value = String(collectionMoq);
          collectionInput.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        if (isMinus && current <= collectionMoq) {
          event.preventDefault();
          event.stopImmediatePropagation();
          collectionInput.value = '0';
          collectionInput.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }
    var fix = event.target.closest('[data-domotec-fix-qty]');
    if (!fix) return;
    var row = fix.closest('.cart-item');
    var input = row && row.querySelector('input[name="updates[]"], .quantity__input');
    if (!input) return;
    input.value = fix.dataset.domotecFixQty;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.classList.add('domotec-moq-enabled');
    setupProductChooser();
    enforceCollectionMinimums();
    enhanceCartRows();
    correctSoldOutLabels();
    lockPreviewOrdering();
    getEurRate().then(function (rate) {
      currentEurRate = rate;
      addEurPrices(rate);
      document.querySelectorAll('.domotec-pack-chooser').forEach(function (chooser) {
        if (chooser.domotecRefreshPrice) chooser.domotecRefreshPrice();
      });
      enforceCartMinimum(rate);
    });
    var observer = new MutationObserver(function () {
      enforceCollectionMinimums();
      enhanceCartRows();
      lockPreviewOrdering();
      if (currentEurRate) enforceCartMinimum(currentEurRate);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();

